// TODO: UI Upgrade - Not sure what to do about this component. It's kind of a mess and isn't very clear what its purpose is.
// It's suppose to act like a generic "public" page, passing whichever values you want for things like 'title' and 'bannerImg'.
// But that seems like overkill for just a handful of public pages, like login and verify. Something like this would make sense
// only if all of our pages followed a uniform, predictable content setup and all page content were loaded via a data source.
// And not to mention we'd need a clearly-defined data source (like a 'page_content' table or in-memory object or something).
import React, { useEffect, useState } from 'react'
import { CssBaseline, Typography } from '@material-ui/core'
import LOGO_URL from '../../assets/logo.svg'
import LOGO_LIGHT_URL from '../../assets/logoLight.svg'
import usePublicWrapperStyles from './public-wrapper.styles'
import { FCB_PRIVACY_STATEMENT, SVB_ECOA_URL } from '../../utils/urls'
import STATIC_TEXT from '../../content/common.json'
import Logout from '../logout/logout'

const DEFAULT_BANNER_SIZE = {
    WIDTH: 1468,
    HEIGHT: 461
}

interface PublicWrapperProps {
    children?: React.ReactElement | React.ReactElement[]
    title?: string
    bannerImgUrlRectangle?: string
    bannerImgUrlRectangleRocket?: string
    bannerSubmit?: string
    bannerNext?: string
    bannerEclipse?: string
    buttonLogout?: string
    contactInfo?: JSX.Element
    bannerImgUrlWomanWorkingOnlaptop?: string
    secondaryContent?: JSX.Element
    heading?: JSX.Element
    heading1?: JSX.Element
    heading2?: JSX.Element
    heading3?: JSX.Element
    heading4?: JSX.Element
    heading5?: JSX.Element
    heading6?: JSX.Element
    input?: JSX.Element
    checkBox?: JSX.Element
    radioButton?: JSX.Element
    buttonGroup?: JSX.Element
    button?: JSX.Element
    additionalContent?: JSX.Element
    content?: JSX.Element
    content2?: JSX.Element
    content3?: JSX.Element
    content4?: JSX.Element
    displaySecondaryOnMobile?: boolean
    displayPrivacyPolicyFooter?: boolean
    backgroundClass?: any
    darkTheme?: boolean
    inUsPage?: boolean
}

const PublicWrapper: React.FC<PublicWrapperProps> = ({
    children,
    title,
    bannerImgUrlRectangle,
    bannerImgUrlRectangleRocket,
    bannerSubmit,
    bannerNext,
    buttonLogout,
    bannerEclipse,
    bannerImgUrlWomanWorkingOnlaptop,
    heading1,
    heading2,
    heading,
    heading3,
    heading4,
    heading5,
    heading6,
    input,
    checkBox,
    radioButton,
    buttonGroup,
    button,
    additionalContent,
    content2,
    content3,
    content4,
    displaySecondaryOnMobile,
    displayPrivacyPolicyFooter,
    inUsPage = true,
    backgroundClass,
    darkTheme,
    secondaryContent
}) => {
    const [bannerHeight, setBannerHeight] = useState(0)
    const classes = usePublicWrapperStyles({
        bannerImgUrlRectangle,
        bannerImgUrlRectangleRocket,
        buttonLogout,
        bannerSubmit,
        bannerNext,
        bannerEclipse,
        bannerImgUrlWomanWorkingOnlaptop,
        displaySecondaryOnMobile,
        bannerImageHeight: bannerHeight
    })

    useEffect(() => {
        const handleResize = (): void => {
            const viewportWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
            const newHeight = (DEFAULT_BANNER_SIZE.HEIGHT / DEFAULT_BANNER_SIZE.WIDTH) * viewportWidth

            setBannerHeight(newHeight)
        }

        window.addEventListener('resize', handleResize)
        handleResize()

        return (): void => {
            window.removeEventListener('resize', handleResize)
        }
    }, []) // eslint-disable-line

    return (
        <>
            <CssBaseline />
            <div className={`${classes.container} ${backgroundClass ? backgroundClass : classes.whiteBg}`}>
                {bannerImgUrlRectangle && (
                    <div className={classes.imgBackground}>
                        <img src={bannerImgUrlRectangle} alt="" width="900px" height="899px" />
                    </div>
                )}
                {bannerImgUrlRectangleRocket && (
                    <div className={classes.imgBackground}>
                        <img src={bannerImgUrlRectangleRocket} alt="" style={{ width: '100%' }} />
                    </div>
                )}

                <div className={classes.root}>
                    <div className={classes.contentColumn}>
                        <header className={classes.header}>
                            <img className={classes.logo} src={darkTheme ? LOGO_LIGHT_URL : LOGO_URL} alt="First Citizens Bank" />
                        </header>
                        <div className={!inUsPage ? `${classes.bannerContainer}` : `${classes.usPageBannerContainer}`}>
                            {title && (
                                <Typography
                                    variant="h2"
                                    style={{ width: '611px', fontWeight: '700', color: '#212121' }}
                                    className={classes.bannerTitle}
                                >
                                    {title}
                                </Typography>
                            )}
                            {secondaryContent && <div className={classes.secondaryContent}>{secondaryContent}</div>}
                            {heading && <div className={classes.heading}>{heading}</div>}
                            {input && <div className={classes.marginUp}>{input}</div>}
                            {checkBox && <div className={classes.marginUp}>{checkBox}</div>}
                            {radioButton && <div className={classes.marginUp}>{radioButton}</div>}
                            {additionalContent && <div className={classes.additionalContent}>{additionalContent}</div>}
                            {content4 && <div>{content4}</div>}
                            {buttonGroup && <div className={classes.buttonGroup}>{buttonGroup}</div>}
                            {button && <div className={classes.marginUp}>{button}</div>}
                            {buttonLogout && (
                                <div style={{ paddingTop: 16 }}>
                                    <Logout showButton={true} />
                                </div>
                            )}
                            {content2 && (
                                <div className={classes.content2} style={{ display: 'inline' }}>
                                    {content2}
                                </div>
                            )}

                            {/* If passed the /portal page contents,
                                this is the only section in this component that actually
                                does anything...
                            */}
                            <div className={classes.content}>{children}</div>

                            {displayPrivacyPolicyFooter && (
                                <footer className={classes.footerNonMobile}>
                                    <a
                                        className={classes.footerLink}
                                        rel="noopener noreferrer"
                                        target="_blank"
                                        href={FCB_PRIVACY_STATEMENT}
                                    >
                                        {STATIC_TEXT.footer.privacyPolicy}
                                    </a>
                                </footer>
                            )}
                        </div>
                    </div>

                    {(bannerImgUrlRectangle || bannerImgUrlWomanWorkingOnlaptop) && (
                        <div className={classes.imageColumn}>
                            {heading4}
                            {heading5}
                            {heading6}
                            {bannerImgUrlRectangle && <img src={bannerImgUrlRectangle} className={classes.imageColumnBg} alt="" />}
                            {bannerImgUrlWomanWorkingOnlaptop && (
                                <img
                                    src={bannerImgUrlWomanWorkingOnlaptop}
                                    className={classes.workingWomanImg}
                                    width="1019px"
                                    height="680px"
                                    style={{ alignSelf: 'center', marginLeft: '100px' }}
                                    alt=""
                                />
                            )}
                        </div>
                    )}

                    {bannerImgUrlRectangleRocket && !inUsPage && (
                        <div className={classes.applicationBox}>
                            {bannerSubmit && <div className={classes.bannerComplete}>{heading5}</div>}
                            {bannerSubmit && (
                                <div className={classes.bannerComplete}>
                                    <img src={bannerSubmit} className={classes.bannerComplete} alt="" />
                                    {heading1}
                                </div>
                            )}
                            {bannerEclipse && (
                                <div className={classes.bannerComplete}>
                                    <img src={bannerEclipse} className={classes.bannerComplete} alt="" />
                                    {heading2}
                                </div>
                            )}
                            {bannerNext && (
                                <div>
                                    <img src={bannerNext} className={classes.bannerComplete} alt="" />
                                    {heading3}
                                </div>
                            )}
                            {bannerNext && (
                                <div>
                                    <img src={bannerNext} className={classes.bannerComplete} alt="" />
                                    {heading4}
                                </div>
                            )}
                            {bannerImgUrlRectangleRocket && (
                                <img src={bannerImgUrlRectangleRocket} className={classes.imageColumnBg} alt="" />
                            )}
                        </div>
                    )}
                </div>

                {displayPrivacyPolicyFooter && (
                    <footer className={classes.footerMobile}>
                        <a className={classes.footerLink} rel="noopener noreferrer" target="_blank" href={FCB_PRIVACY_STATEMENT}>
                            {STATIC_TEXT.footer.privacyPolicy}
                        </a>
                    </footer>
                )}

                {displayPrivacyPolicyFooter && (
                    <footer className={classes.footerMobile}>
                        <a className={classes.footerLink} rel="noopener noreferrer" target="_blank" href={SVB_ECOA_URL}>
                            {STATIC_TEXT.footer.ECOADisclosure}
                        </a>
                    </footer>
                )}
            </div>
        </>
    )
}

export default PublicWrapper
